/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ProductGroupsResponse as ModelsProductProductGroupsResponse } from '../models/Models/Product/product-groups-response';
import { v4ProductsProductGroupsGet$Json } from '../fn/products/v-4-products-product-groups-get-json';
import { V4ProductsProductGroupsGet$Json$Params } from '../fn/products/v-4-products-product-groups-get-json';
import { v4ProductsProductGroupsGet$Plain } from '../fn/products/v-4-products-product-groups-get-plain';
import { V4ProductsProductGroupsGet$Plain$Params } from '../fn/products/v-4-products-product-groups-get-plain';
import { v4ProductsProductGroupsGet$Xml } from '../fn/products/v-4-products-product-groups-get-xml';
import { V4ProductsProductGroupsGet$Xml$Params } from '../fn/products/v-4-products-product-groups-get-xml';

@Injectable({ providedIn: 'root' })
export class ProductsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v4ProductsProductGroupsGet()` */
  static readonly V4ProductsProductGroupsGetPath = '/v4/products/productGroups';

  /**
   * Gets a list of product groups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ProductsProductGroupsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ProductsProductGroupsGet$Plain$Response(params?: V4ProductsProductGroupsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsProductProductGroupsResponse>> {
    return v4ProductsProductGroupsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of product groups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ProductsProductGroupsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ProductsProductGroupsGet$Plain(params?: V4ProductsProductGroupsGet$Plain$Params, context?: HttpContext): Observable<ModelsProductProductGroupsResponse> {
    return this.v4ProductsProductGroupsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsProductProductGroupsResponse>): ModelsProductProductGroupsResponse => r.body)
    );
  }

  /**
   * Gets a list of product groups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ProductsProductGroupsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ProductsProductGroupsGet$Json$Response(params?: V4ProductsProductGroupsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsProductProductGroupsResponse>> {
    return v4ProductsProductGroupsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of product groups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ProductsProductGroupsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ProductsProductGroupsGet$Json(params?: V4ProductsProductGroupsGet$Json$Params, context?: HttpContext): Observable<ModelsProductProductGroupsResponse> {
    return this.v4ProductsProductGroupsGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsProductProductGroupsResponse>): ModelsProductProductGroupsResponse => r.body)
    );
  }

  /**
   * Gets a list of product groups.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v4ProductsProductGroupsGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ProductsProductGroupsGet$Xml$Response(params?: V4ProductsProductGroupsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsProductProductGroupsResponse>> {
    return v4ProductsProductGroupsGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a list of product groups.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v4ProductsProductGroupsGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  v4ProductsProductGroupsGet$Xml(params?: V4ProductsProductGroupsGet$Xml$Params, context?: HttpContext): Observable<ModelsProductProductGroupsResponse> {
    return this.v4ProductsProductGroupsGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<ModelsProductProductGroupsResponse>): ModelsProductProductGroupsResponse => r.body)
    );
  }

}
